import { createFileRoute } from '@tanstack/react-router'

import { conflictsQuery, dayQuery, flagsQuery, productsQuery, settingsQuery } from '../lib/queries'
import { Today } from '../screens/Today'

export const Route = createFileRoute('/')({
  validateSearch: (search: Record<string, unknown>): { slot?: 'morning' | 'evening' } => ({
    slot: search.slot === 'evening' ? 'evening' : search.slot === 'morning' ? 'morning' : undefined,
  }),
  loader: ({ context }) =>
    Promise.all([
      context.queryClient.ensureQueryData(dayQuery('today')),
      context.queryClient.ensureQueryData(productsQuery()),
      context.queryClient.ensureQueryData(settingsQuery()),
      context.queryClient.ensureQueryData(conflictsQuery()),
      context.queryClient.ensureQueryData(flagsQuery()),
    ]),
  component: Today,
})
